import React from 'react';
import {removeHTML} from '../../framework/utilities';

export default function UpcomingList({ pastContestArticles }) {
  const resultsRender = [];

  for (let article = 0; article < pastContestArticles.length; article += 3) {
    resultsRender.push(
      <>
        <div data-card-size="small" className="grid card__grid">
          {pastContestArticles.slice(article, article + 3)
            .map(article => (
                <div className="grid__col-lg-4 grid__col-xs-12">
                  <article key={article.id} className={`card ${(article.sponsored) ? "card--sponsored" : ""}`}>
                    <a href={article.url}>
                      <img
                        src={(article.image['card-medium']) ? article.image['card-medium'] : article.image}
                        className="card__media"
                        alt={removeHTML(article.title)}
                      />
                      <section className="card__body card__body--small">
                          <p className="card__category">{article.kicker}</p>
                          <h4 className="card__title" dangerouslySetInnerHTML={{__html: article.title}} />
                          <p className="card__description" dangerouslySetInnerHTML={{__html: article.subheader}} />
                      </section>
                    </a>
                    <hr className="card__hr"/>
                  </article>
              </div>
            ))
          }
        </div>
        <hr className="section__hr" />
      </>
    )
  }

  return (resultsRender);
}
